var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 10.753a2 2 0 0 0 0-4 2 2 0 0 0 0 4z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.655 10.371c-.668-1.7-1.892-4.152-3.932-6.183-2.033-2.024-4.46-3.213-6.137-3.854-1.841-.704-3.934-.26-5.331 1.13L11.346 6.35c-1.455 1.448-1.874 3.677-1.044 5.545l.837 1.694L.366 24.362a1.25 1.25 0 0 0-.366.884v5.5a1.25 1.25 0 0 0 1.25 1.25h5.5A1.25 1.25 0 0 0 8 30.746v-2.25h2.25a1.25 1.25 0 0 0 1.25-1.25v-2.25h2.25a1.25 1.25 0 1 0 0-2.5h-3.5A1.25 1.25 0 0 0 9 23.746v2.25H6.75a1.25 1.25 0 0 0-1.25 1.25v2.25h-3v-3.732l11.085-11.085a1.25 1.25 0 0 0 .185-1.532c-.433-.714-.831-1.477-1.183-2.268a2.49 2.49 0 0 1 .523-2.757l4.909-4.886a2.52 2.52 0 0 1 2.675-.567c1.451.555 3.543 1.576 5.266 3.291 1.733 1.725 2.789 3.848 3.369 5.325a2.48 2.48 0 0 1-.56 2.668L23.8 18.898c-.723.72-1.803.93-2.751.536a16.23 16.23 0 0 1-2.25-1.148 1.25 1.25 0 1 0-1.308 2.131c.822.505 1.696.95 2.598 1.325a5.01 5.01 0 0 0 5.475-1.073l4.968-4.944a4.98 4.98 0 0 0 1.124-5.354z",
    fill: "url(#B)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 20.75,
    y1: 8.763,
    x2: 24.75,
    y2: 8.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 0,
    y1: 16.077,
    x2: 32,
    y2: 16.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.3bc63578ce25660c239d49f0f8072ace.svg";
export { ForwardRef as ReactComponent };